import browserUtils from 'utilities/src/browserUtils';
import checkAnalyticsFunctionMap from '../utils/checkAnalyticsFunctionMap';
import ga from './ga4';

const sendMutinyExperienceToSegment = (ga4Key?: string) => {
  browserUtils.windowPage?.addEventListener('mutiny:experience-impression', (event: any) => {
    ga.assignEvent(ga4Key, 'experiment-assigned', {
      type: 'Mutiny',
      ...(event?.detail ?? {}),
    });
  });
};

const mutiny = {
  sendMutinyExperienceToSegment,
};

export default checkAnalyticsFunctionMap(mutiny) as typeof mutiny;
